import Translation from "src/translations/locales/translation";

import { useTranslation } from "react-i18next";
import { Alignment } from "src/components/alignment";
import { GetUrlParams } from "src/utils/GetUrlParams";
import { DyanmicOverview } from "src/composable/base-dynamic-overview";
import { Collection, CollectionsRepository } from "src/components/collection";

class InnerCollectionsOverviewScreen extends DyanmicOverview<Collection> {
  getTitle(): string | null {
    return this.state.item?.title ?? "";
  }

  getDescription(): string | null {
    return this.state.item?.shortDescription ?? "";
  }

  getThumbnail(): string | null {
    return this.state.item?.thumbnail ?? "";
  }

  getMoreInfoText(): string | null {
    return this.props.t(Translation.screens.overviews.moreInfoText);
  }

  getThumbnailAlignment(): Alignment | null {
    return this.state.item?.thumbnailAlignment ?? null;
  }
}

export default function CollectionsOverviewScreen() {
  const { t } = useTranslation();

  const id = GetUrlParams();

  return (
    <InnerCollectionsOverviewScreen
      loadItem={async () => await new CollectionsRepository().get({})}
      id={id ?? null}
      t={t}
    />
  );
}
